import angular from "angular"
import "./table.component.css"
const templateUrl = require("ngtemplate-loader!html-loader!./table.component.html")
const DT_OPTIONS = {
  sProcessing: "Procesando...",
  sLengthMenu: "Mostrar _MENU_ registros",
  sZeroRecords: "No se encontraron resultados",
  sEmptyTable: "No se encontraron resultados",
  sInfo: "_START_ a _END_ de _TOTAL_",
  sInfoEmpty: "",
  sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
  sInfoPostFix: "",
  sSearch: "",
  sUrl: "",
  sInfoThousands: ".",
  sLoadingRecords: "Cargando...",
  oPaginate: {
    sFirst: "|<",
    sLast: ">|",
    sNext: ">",
    sPrevious: "<"
  },
  oLanguage: { sLoadingRecords: "test text" },
  oAria: {
    sSortAscending: ": Activar para ordenar la columna de manera ascendente",
    sSortDescending: ": Activar para ordenar la columna de manera descendente"
  }
}

TableComponent.$inject = ["DTOptionsBuilder", "$timeout", "appRoutesService", "$state"]
function TableComponent(DTOptionsBuilder, $timeout, appRoutesService, $state) {
  var vm = this
  vm.dtColumnDefs = []
  vm.dtInstance = {}
  vm.rows = []
  vm.selected = {}
  vm.recordsPerPage = 50
  vm.currentPage = 1
  vm.tableReady = false
  vm.selectedAll = false

  vm.toggleSelectedRow = function() {
    vm.selectedAll = vm.areChecked()
  }

  vm.toggleSelectAll = function() {
    for (var i = 0; i < vm.rows.length; i++) {
      vm.rows[i].isSelected = vm.selectedAll
    }
  }

  vm.areChecked = function() {
    var total = vm.rows.length
    var countSelected = 0
    var conjunction = true
    for (var i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i].isSelected) {
        countSelected += 1
      }
      conjunction = conjunction && vm.rows[i].isSelected
    }
    return conjunction && total == countSelected
  }

  vm.getSelection = function(propertiesCallback) {
    var selected = []
    if (!propertiesCallback) {
      propertiesCallback = function(row) {
        return row.id
      }
    }
    for (var i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i].isSelected) {
        selected.push(propertiesCallback(vm.rows[i]))
      }
    }
    return selected
  }

  vm.dtOptions = DTOptionsBuilder.newOptions()
    .withLanguage(DT_OPTIONS)
    .withPaginationType("simple")
    .withDisplayLength(vm.recordsPerPage)
    .withOption("processing", false)
    .withOption("scrollY", "50vh")
    .withOption("scrollX", "100%")
    .withDOM("ft")

  vm.reloadTable = function() {
    vm.tableReady = false
    let tableName = "agenda"
    let offset = (vm.currentPage - 1) * vm.recordsPerPage
    vm.rowsPromise(tableName, offset).then(function(data) {
      vm.rows = data.results
      //new options -----
      vm.showing = data.results.length
      vm.full_count = data.count
      vm.start_index = (vm.currentPage - 1) * vm.recordsPerPage + 1
      vm.end_index = vm.start_index + vm.showing - 1
      vm.recordsLeft = vm.full_count - vm.end_index
      // ----------------
      vm.selectedAll = false
      $timeout(function() {
        vm.dtInstance.rerender()
        vm.tableReady = true
      }, 1)
    })
  }

  vm.$onChanges = function(data) {
    if (vm.reloadTable && vm.dtInstance.rerender) {
      if (data.reload || data.columns) {
        vm.reloadTable()
      }

      if (data.doDelete) {
        vm.deleteRows({ models: vm.getSelection() })
      }

      if (data.doEdit) {
        vm.editRows({
          models: vm.getSelection(function(row) {
            return row
          })
        })
      }
    }
  }

  vm.$onInit = function() {
    if (vm.maxRows) {
      vm.dtOptions["iDisplayLength"] = vm.maxRows
    }

    vm.reloadTable()
  }

  vm.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev)
  }

  // new options
  vm.prevPage = function() {
    if (vm.currentPage > 1) {
      vm.currentPage -= 1
      vm.reloadTable()
    }
  }

  vm.nextPage = function() {
    if (vm.recordsLeft > 0) {
      vm.currentPage += 1
      vm.reloadTable()
    }
  }

  vm.goToAttention = function(row) {
    if (Boolean(vm.clickOnrow)) {
      $state.go("app.profile.attention", {
        studentId: row.alumno_id,
        attentionId: row.id
      })
    }
  }
}

angular.module("appModule").component("tabla", {
  templateUrl: templateUrl,
  bindings: {
    columns: "<",
    rowsPromise: "<",
    reload: "<",
    doDelete: "<",
    doEdit: "<",
    editRows: "&",
    deleteRows: "&",
    menuOptions: "<",
    maxRows: "<",
    clickOnrow: "<"
  },
  controller: TableComponent
})
